import React from "react"
import classnames from "classnames"
import {
  Button,
  Container,
  Section,
  AlertIcon,
  TickModalIcon,
  Caption,
  Space,
  Interactive,
  H6,
  A,
  H3
} from "AtomicComponents"
import HeroContent from "../HeroContent/HeroContent"
import gtmHandler from "AtomicUtils/gtmHandler"
import RecallDetail from "../RecallDetail/RecallDetail"
import Disclaimer from "../Disclaimer/Disclaimer"
import styles from "./RecallDocument.less"
import parseRecallActivities from "AtomicUtils/parseRecallActivities"
// import dateHandler from "AtomicUtils/dateHandler"

class RecallDocument extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      Status: ""
    }
  }

  componentDidMount(){
    this._handleStatus()
  }

  _handleOnClickBook = () => {
    const { Status } = this.state
    gtmHandler({
      pageCategory: "Recalls",
      pageAction: `Recalls - Recall Status "${Status}" - Clicked "${"Book Your free repair".toUpperCase()}"`
    })
  }

  _handleOnClickDownload = () => {
    const { Status } = this.state
    gtmHandler({
      pageCategory: "Recalls",
      pageAction: `Recalls - Recall Status "${Status}" - Clicked "${"Download Report".toUpperCase()}"`
    })
  }

  _handleStatus = () => {
    const { recallActivities } = this.props
    const { Status } = parseRecallActivities(recallActivities)

    this.setState({
      Status: Status
    })
  }

  _handleNoRecall = () => {
    const { handleNoRecall = () => {} } = this.props
    handleNoRecall()
  }

  render() {
    const {
      heading = "MAZDA RECALLS",
      description = "View you vehicles details below",
      modelDescription,
      vin,
      productionYear,
      recallActivities,
      activeToolTip,
      pendingToolTip,
      accessedTime,
      recallLink,
      pdfLink,
      handleNoRecall,
      findADealerCta,
      bookCTALink,
      noLongerOwningLink
    } = this.props

    // This was a feature that we removed through the new needs
    // const accessedTime = new dateHandler(new Date()).format('0D/0M/YYYY 0h:0mm A')

    const { Status, NumberOfActive, NumberOfPending, NumberOfAll } = parseRecallActivities(recallActivities)

    return (
      <div className={classnames({
        [styles.RecallDocument]: true
      })}>
        {(heading || description) &&
          <Section backgroundColor="#F5F5F5" padding>
            <HeroContent
              heading={heading}
              description={description} />
          </Section>
        }
        <Space />
        <Section>
          <Container styleName='screen'>
            <div className={classnames({
              [styles.RecallResult]: true
            })}>
              <div className={classnames({
                [styles.RecallDocumentInfo]: true
              })}>
                {modelDescription &&
                  <div>
                    <strong>Model:</strong> {modelDescription}
                  </div>
                }
                {vin &&
                  <div>
                    <strong>VIN:</strong> {vin}
                  </div>
                }
                {productionYear &&
                  <div>
                    <strong>Year:</strong> {productionYear}
                  </div>
                }
              </div>
              <div className={classnames({
                [styles.RecallBoxParent]: true
              })}>
                <Section backgroundColor="#FFFFFF" border>
                  <div className={classnames({
                    [styles.RecallBox]: true
                  })}>
                    <div className={classnames({
                      [styles.RecallBoxHeading]: true,
                      [styles.RecallBoxHeadingRED]: NumberOfAll > 0,
                      [styles.RecallBoxHeadingGREEN]: NumberOfAll === 0
                    })}>
                      <div>
                        { NumberOfAll > 0 &&
                          <AlertIcon style={{
                            width: "2em",
                            height: "2em"
                          }} />
                        }
                        {NumberOfAll === 0 &&
                          <TickModalIcon style={{
                            width: "2em",
                            height: "2em"
                          }} />
                        }
                        <H3 withDetails>
                          {Status}
                        </H3>
                      </div>
                    </div>
                    {NumberOfAll > 0 &&
                      <div className={classnames({
                        [styles.RecallActivePending]: true
                      })}>
                        <div className={classnames({
                          [styles.RecallActivePendingInfo]: true
                        })}>
                          <strong>{NumberOfActive}</strong>
                          &nbsp;
                          Active Recall{NumberOfActive > 1 ? "s" : ""}
                          <Disclaimer>{activeToolTip}</Disclaimer>
                        </div>
                        <div className={classnames({
                          [styles.RecallActivePendingMiddle]: true
                        })}>
                          <Caption>|</Caption>
                        </div>
                        <div className={classnames({
                          [styles.RecallActivePendingInfo]: true
                        })}>
                          <strong>{NumberOfPending}</strong>
                          &nbsp;
                          Pending Recall{NumberOfPending > 1 ? "s" : ""}
                          <Disclaimer>
                            {pendingToolTip}
                          </Disclaimer>
                        </div>
                      </div>
                    }
                    <div className={classnames({
                      [styles.RecallBoxButtons]: true,
                      [styles.RecallBoxButtonsOneButton]: !handleNoRecall && !recallLink
                    })}>
                      <Button styleName="blackOutlined" external href={pdfLink} onClick={this._handleOnClickDownload}>
                        Download Report
                      </Button>
                      {NumberOfAll > 0 &&
                        <Button
                          styleName="black"
                          external={bookCTALink && bookCTALink.props && bookCTALink.props.external}
                          onClick={this._handleOnClickBook}
                          href={bookCTALink && bookCTALink.props && bookCTALink.props.href}>
                          {(bookCTALink && bookCTALink.props && bookCTALink.props.label) || "Book Your free repair"}
                        </Button>
                      }
                      {NumberOfAll === 0 && handleNoRecall &&
                        <Button styleName="black" onClick={this._handleNoRecall}>
                          Check another vehicle
                        </Button>
                      }
                      {NumberOfAll === 0 && !handleNoRecall && recallLink &&
                        <Button styleName="black" external href={recallLink} >
                          Check another vehicle
                        </Button>
                      }
                    </div>
                    <span>
                      If you no longer own this vehicle <A href={noLongerOwningLink}> click here </A>
                    </span>
                    <Space />
                    <span>
                      <strong>Result returned on:</strong> <span className={classnames({
                        [styles.RecallWhiteSpace]: true
                      })}>{accessedTime}</span>
                    </span>
                  </div>
                </Section>
              </div>
              {recallActivities && recallActivities.map((recall, index) => (
                <div
                  key={`RecallDetail-${index}`}
                  className={classnames({
                    [styles.RecallActivities]: true
                  })}>
                  <Section>
                    <div className={classnames({
                      [styles.RecallDetail]: true,
                      [styles.RecallDetailBorder]: (index < recallActivities.length - 1)
                    })}>
                      <RecallDetail {...recall} />
                    </div>
                  </Section>
                </div>
              ))}

              <div className={classnames({
                [styles.RecallBoxBottomButtons]: true
              })}>
                {handleNoRecall &&
                  <Button styleName={NumberOfAll>0?"white":"black"} onClick={this._handleNoRecall}>
                    Check another vehicle
                  </Button>
                }
                {!handleNoRecall && recallLink &&
                  <Button styleName={NumberOfAll > 0 ? "white" : "black"} external href={recallLink} >
                    Check another vehicle
                  </Button>
                }
                {NumberOfAll > 0 && findADealerCta &&
                  <Button styleName="black" external href={findADealerCta.props.href}>
                    {findADealerCta.props.label}
                  </Button>
                }
              </div>
            </div>
          </Container>
        </Section>
      </div>
    )
  }
}


export default RecallDocument



// WEBPACK FOOTER //
// ./src/AtomicContainers/RecallDocument/RecallDocument.jsx